import { Text } from '@mantine/core';
import { DateTimePicker, DateTimePickerProps } from '@mantine/dates';

import { IconCalendar } from '@tabler/icons-react';

import classes from './DateTimeField.module.css';

export const DateTimeField = ({ ...props }: DateTimePickerProps) => {
	return (
		<DateTimePicker
			classNames={classes}
			radius="lg"
			// valueFormat={valueFormat}
			label={
				<Text c="#667085" fz={12} fw={500} lh="normal" tt="uppercase">
					Дата и время
				</Text>
			}
			rightSection={<IconCalendar opacity={0.5} />}
			size="md"
			{...props}
		/>
	);
};
